
  import {
    Component,
    Vue
  } from 'vue-property-decorator';
  import {
    todayStatistics,
    getProductSalesStatistics,
    providerRankList,
    lianChuangRankList,
    productSellStatisList
  } from '@/api/statistic';
  import {
    RoleData
  } from '@/utils/config'
  import {
    getUserInfo
  } from '@/utils/storage'
  import {
    getMenuPermission
  } from '@/api/user';

  import { PermissionModule } from '@/store/modules/permission'
  @Component({
    name: 'home-index',
    components: {
      
    }
  })
  export default class HomeIndex extends Vue {
    private defaultAvatar = 'https://cdn2024.shiwuzone.com/routuan/image/20230110-0f54988a-9589-45bc-ad27-844c60e80f36.png'

    private todayData: any = {};
    private productRankList: any = [];
    private roles = RoleData;
    private haveAuth:any = true;
    private lisnchuanglist:any = []
    private providerlist:any = []
    private productSelllist:any = []
    private commonList = [
      {path:'/product/list',label:'商品库',icon:'',name:'Product_List'},
      {path:'/order/list',label:'订单查询',icon:'',name:'Order_List'},
      {path:'/aftersales/list',label:'售后单管理',icon:'',name:'After_List'},
      {path:'/member/list',label:'分销员管理',icon:'',name:'Member_List'},
      {path:'/malldecoration/customizepage',label:'自定义页面',icon:'',name:'customizepage'},
    ]

    private mounted() {
      
      this.getAuthData();
      
    }

    private get userInfo() {
      return getUserInfo();
    }


    private async getAuthData(){
       try {
        const res: any = await getMenuPermission({});
        if(res.IsSuccess){
          
          let list = res.Result;
          let homes = list.filter(item=>{
            return item.Sref == 'Home';
          })
          if (homes.length){
            this.haveAuth = true;
            this.getTodayStatistics();
            this.getproductSellStatisList();
            this.getlianChuangRankList()
            this.getproviderRankList()
          }else{
            this.haveAuth = false;
          }
        }

      } catch (e) {
      }
    }
    private async getproductSellStatisList(){
      try{
        let res:any = await productSellStatisList({})
        if(res.IsSuccess){
          this.productSelllist = res.Result
        }
      }finally{
        //
      }
    }

    private async getproviderRankList(){
      try{
        let res:any = await providerRankList({})
        if(res.IsSuccess){
          this.providerlist = res.Result
        }
      }finally{
        //
      }
    }
    private async getlianChuangRankList(){
      try{
        let res:any = await lianChuangRankList({})
        if(res.IsSuccess){
          this.lisnchuanglist = res.Result
        }
      }finally{
        //
      }
    }

    /**
     * 获取今日数据
     */
    private async getTodayStatistics() {
      let today = parseInt(new Date(new Date().toLocaleDateString()).getTime() / 1000 + '');
      try {
        const res: any = await todayStatistics({
          time: today
        });
        if(res.IsSuccess){
          
          this.todayData = res.Result;
          this.productRankList = res.Result.HomeProductSellStatisList

        }
      } catch (e) {
        console.log('getTodayStatistics ===>', e)
      }
    }

    /**
     * 获取商品排行
     */
    private async getProductRank() {
      
      try {

        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth()+1;

        const res: any = await getProductSalesStatistics({
          Skip: 0,
          Take: 10,
          StartTime: year+'-'+month+'-1 00:00:00',
          EndTime: year+'-'+(month+1)+'-1 00:00:00',
        });
        this.productRankList = res.Result.Result.Results;
      } catch (e) {
        console.log('productRank ===>', e)
      }
    }
  }
